import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";

import config from "@/lib/config";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";

class PlaybackEngine extends RESTDataSource {
  baseURL = config.playback.url;
  merchantId = config.playback.merchantId;

  constructor(options) {
    super(options);
    this.context = options;
  }

  setPlaybackSessionId(sessionId) {
    if (this.context.req) {
      this.context.req.playbackSessionId = sessionId;
    }
  }

  async open(mediaId, sessionId) {
    const params = {
      user_id: this.context?.req?.userToken?.id,
    };
    this.setPlaybackSessionId(sessionId);
    return this.get(
      `/session_proxy/open/v1/merchants/${this.merchantId}/medias/${mediaId}`,
      { params }
    );
  }

  async check(sessionId) {
    this.setPlaybackSessionId(sessionId);
    return this.post("/session/check", {});
  }

  async close(sessionId) {
    this.setPlaybackSessionId(sessionId);
    return this.post(`/session_proxy/close`, {});
  }

  willSendRequest(_path, request) {
    // UAをプロキシする
    request.headers[
      "User-Agent"
    ] = `${this.context.req.deviceInfo.ua} spooxweb`;

    if (this.context.req?.userToken) {
      const { id, accessToken } = this.context.req.userToken;
      request.headers["X-User-Id"] = id;

      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    if (_path.includes("/session_proxy/open")) {
      const remoteIp = getRemoteIpAddress(this.context.req);
      if (remoteIp !== "0.0.0.0") {
        request.headers["X-Forwarded-For"] = remoteIp;
      }
    }
    if (this.context?.req?.playbackSessionId) {
      request.headers[
        "X-Playback-Session-Id"
      ] = this.context?.req?.playbackSessionId;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Playback-Request-Id"] = requestId;
    const userId = request.headers["X-User-Id"];
    console.log(
      `[${requestId}][Playback][REQUEST INFO] Method: ${request.method}, Path: ${request.path}, UserId: ${userId}`
    );
  }

  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Playback-Request-Id"];
    console.log(
      `[${requestId}][Playback][RESPONSE INFO] Status: ${response.status}`
    );
    return super.didReceiveResponse(response, request);
  }
}
export default PlaybackEngine;
